





































































































































































module.exports =
  name: 'app'
  components:
    Departure: require('components/Departure')
    Tier: require('components/Tier')
    Themes: require('components/Themes')




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue